import { render, staticRenderFns } from "./BugVxeGrid.vue?vue&type=template&id=894421b6&scoped=true&"
import script from "./BugVxeGrid.vue?vue&type=script&lang=js&"
export * from "./BugVxeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894421b6",
  null
  
)

export default component.exports